import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

/**
 * Displays text that types out character-by-character at a given delay.
 * Used inside fake form inputs to simulate a user filling the form.
 */
export default function TypedText({ text = '', delay = 0, speed = 24, className = '', prefix = null, showCaret = true }) {
  const [out, setOut] = useState('');
  const [started, setStarted] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => setStarted(true), delay * 1000);
    return () => clearTimeout(startTimer);
  }, [delay]);

  useEffect(() => {
    if (!started) return;
    let i = 0;
    const id = setInterval(() => {
      i++;
      setOut(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(id);
        setDone(true);
      }
    }, speed);
    return () => clearInterval(id);
  }, [started, text, speed]);

  return (
    <span className={className}>
      {prefix}
      {out}
      {showCaret && started && !done && (
        <motion.span
          animate={{ opacity: [1, 0, 1] }}
          transition={{ duration: 0.6, repeat: Infinity }}
          className="inline-block w-[1px] h-[1em] bg-teal-600 align-middle ml-[1px]"
        />
      )}
    </span>
  );
}
